export const ProductionTerminalRoutes = {
  all: () => '/production',
  show: ({workplaceNo}) => `/production/${workplaceNo}`,
};
